import React from 'react';
import { RouteComponentProps } from '@reach/router';
import { Text } from '@el8/vital';
import { computePhysicianFullName } from 'modules/physician';
import { DateTime } from 'luxon';
import { LuxonFormats, PhysicianInfo, PracticeInfo, State } from 'types';
import { Appointment, AppointmentType } from 'EntityTypes';

import { Box } from 'components';

import { getChart } from 'modules/chart';
import { useSelector } from 'react-redux';
import styles from './AppointmentDetails.less';

type Props = {
  appointment: Appointment;
  appointmentType: AppointmentType;
  physician: PhysicianInfo;
  practice: PracticeInfo;
} & RouteComponentProps;

const AppointmentDetails: React.FC<Props> = ({
  appointment,
  appointmentType,
  physician,
  practice,
  // serviceLocation,
}) => {
  const chart = useSelector((state: State) => getChart(state, { chartId: appointment.patient }));
  const { fhirLocation } = appointment;
  const apptTime = DateTime.fromISO(appointment.apptTime, {
    zone: chart.timezone || fhirLocation?.timezone || practice.timezone,
  });
  return (
    <Box direction="column" align="left">
      {appointmentType && (
        <Text className={styles.text} weight="bold" tag="div">
          {appointmentType.name}
        </Text>
      )}
      <Text className={styles.text} tag="div">
        {`${appointment.isTelehealth ? 'Virtual' : 'In Person'} Visit`}
      </Text>
      <Text className={styles.text} tag="div">
        {computePhysicianFullName(physician, { withCredentials: true })}
      </Text>
      <br />
      <Text weight="bold" className={styles.text}>{`${apptTime.toFormat(
        LuxonFormats.Date,
      )} `}</Text>
      <Text className={styles.text}>{apptTime.toFormat(LuxonFormats.TimeWithTimeZone)}</Text>
      {!appointment.isTelehealth && fhirLocation && (
        <>
          <br />
          <Text className={styles.text} weight="bold" tag="div">
            Clinic Location
          </Text>
          <Text className={styles.text} tag="div">
            {`${fhirLocation.addressLine1}${fhirLocation.addressLine2 ?? ''}`}
          </Text>
          <Text className={styles.text} tag="div">
            {`${fhirLocation.city}, ${fhirLocation.state} ${fhirLocation.zipCode}`}
          </Text>
          {fhirLocation.phone && (
            <Text className={styles.text}>
              <a href={`tel:${fhirLocation.phone}`}>{fhirLocation.phone}</a>
            </Text>
          )}
        </>
      )}
    </Box>
  );
};

export default AppointmentDetails;
